import angular from 'angular';

angular.module('principal', []);
